import React from "react";
import { Link } from "react-router-dom";
import './Nav.css'
import Menu from './menu.png'
import MobileNav from "../MobileNav";

const Nav = ()=>{
    return <><nav className="nav-container">
        <ul>
            <Link to="/"><li>Home</li></Link>
            <Link to="/SpinCoin"><li>Coin Flip</li></Link>  
            <Link to="/RoadMap"><li>Roadmap</li></Link>
            <Link to="/Raffles"><li>Raffles</li></Link>
            <Link to="/Auctions"><li>Auctions</li></Link>
            <Link to="/Staking"><li>Staking</li></Link>
            <Link to="/MyateryBoxes"><li>Mystery Boxes</li></Link>                            
        </ul>
    </nav>
    <div className="menu">
        <MobileNav/>
    </div>
    
    </>

}

export default Nav